module.exports = __webpack_public_path__ + "media/images/emblems/Goms_(district)-coat_of_arms-46601fe9565e86abe411f6a2aa23b2f5.svg";